import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "dashboard__content" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "row m-0" }
const _hoisted_5 = { class: "h3" }
const _hoisted_6 = { class: "settings__subtitle" }
const _hoisted_7 = { class: "row m-0 settings__filters" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "h4" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "h4" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = {
  key: 0,
  style: {"margin-left":"10px","margin-top":"1px","position":"absolute"},
  class: "p-button-loading-icon pi pi-spinner pi-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dashboard_sidebar = _resolveComponent("dashboard-sidebar")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_main_filter_item = _resolveComponent("main-filter-item")!
  const _component_app_check_box_list = _resolveComponent("app-check-box-list")!
  const _component_range_slider = _resolveComponent("range-slider")!
  const _component_color_filter = _resolveComponent("color-filter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dashboard_sidebar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.mySettings" })
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.text), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h4", _hoisted_9, [
              _createVNode(_component_i18n_t, { keypath: "dashboard.settings.your" }),
              _createTextVNode(" 4 "),
              _createVNode(_component_i18n_t, { keypath: "dashboard.settings.mainFilters" })
            ])
          ]),
          _createVNode(_component_main_filter_item, {
            filter: _ctx.mainFilter1,
            options: _ctx.mainFilter1Options,
            modelValue: _ctx.mainFilter1Model,
            class: _normalizeClass({ 'app-drop-zone-active': !!_ctx.activeDragFilter }),
            "onUpdate:modelValue": _ctx.updateMainFilter1,
            onDrop: _cache[0] || (_cache[0] = (event) => _ctx.onMainFilterDrop('mainFilter1', event)),
            onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
            onDrag: _cache[2] || (_cache[2] = (event) => _ctx.onFilterDrag(_ctx.mainFilter1, event)),
            onDragend: _cache[3] || (_cache[3] = (event) => _ctx.onFilterDragEnd(_ctx.mainFilter1, event))
          }, null, 8, ["filter", "options", "modelValue", "class", "onUpdate:modelValue"]),
          _createVNode(_component_main_filter_item, {
            filter: _ctx.mainFilter2,
            options: _ctx.mainFilter2Options,
            modelValue: _ctx.mainFilter2Model,
            class: _normalizeClass({ 'app-drop-zone-active': !!_ctx.activeDragFilter }),
            "onUpdate:modelValue": _ctx.updateMainFilter2,
            onDrop: _cache[4] || (_cache[4] = (event) => _ctx.onMainFilterDrop('mainFilter2', event)),
            onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
            onDrag: _cache[6] || (_cache[6] = (event) => _ctx.onFilterDrag(_ctx.mainFilter2, event)),
            onDragend: _cache[7] || (_cache[7] = (event) => _ctx.onFilterDragEnd(_ctx.mainFilter2, event))
          }, null, 8, ["filter", "options", "modelValue", "class", "onUpdate:modelValue"]),
          _createVNode(_component_main_filter_item, {
            filter: _ctx.mainFilter3,
            options: _ctx.mainFilter3Options,
            modelValue: _ctx.mainFilter3Model,
            class: _normalizeClass({ 'app-drop-zone-active': !!_ctx.activeDragFilter }),
            "onUpdate:modelValue": _ctx.updateMainFilter3,
            onDrop: _cache[8] || (_cache[8] = (event) => _ctx.onMainFilterDrop('mainFilter3', event)),
            onDragover: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
            onDrag: _cache[10] || (_cache[10] = (event) => _ctx.onFilterDrag(_ctx.mainFilter3, event)),
            onDragend: _cache[11] || (_cache[11] = (event) => _ctx.onFilterDragEnd(_ctx.mainFilter3, event))
          }, null, 8, ["filter", "options", "modelValue", "class", "onUpdate:modelValue"]),
          _createVNode(_component_main_filter_item, {
            filter: _ctx.mainFilter4,
            options: _ctx.mainFilter4Options,
            modelValue: _ctx.mainFilter4Model,
            class: _normalizeClass({ 'app-drop-zone-active': !!_ctx.activeDragFilter }),
            "onUpdate:modelValue": _ctx.updateMainFilter4,
            onDrop: _cache[12] || (_cache[12] = (event) => _ctx.onMainFilterDrop('mainFilter4', event)),
            onDragover: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"])),
            onDrag: _cache[14] || (_cache[14] = (event) => _ctx.onFilterDrag(_ctx.mainFilter4, event)),
            onDragend: _cache[15] || (_cache[15] = (event) => _ctx.onFilterDragEnd(_ctx.mainFilter4, event))
          }, null, 8, ["filter", "options", "modelValue", "class", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["row m-0 settings__select-filter", {
                        'app-drop-zone-active':
                            _ctx.activeDragFilter && !_ctx.showFilter[_ctx.activeDragFilter],
                    }]),
          onDrop: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.onFiltersBlockDrop && _ctx.onFiltersBlockDrop(...args))),
          onDragover: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.onFiltersBlockDragOver && _ctx.onFiltersBlockDragOver(...args)))
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h4", _hoisted_11, [
              _createVNode(_component_i18n_t, { keypath: "dashboard.settings.availableFiltersForSelection" })
            ])
          ]),
          (_ctx.showFilter['promotion'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 0,
                modelValue: _ctx.quickSelectionModel,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.quickSelectionModel) = $event)),
                options: _ctx.filtersDto.quickSelection,
                type: "quickSelection",
                onDrag: _cache[17] || (_cache[17] = (event) => _ctx.onFilterDrag('quickSelection', event)),
                onDragend: _cache[18] || (_cache[18] = (event) => _ctx.onFilterDragEnd('quickSelection', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['gearbox'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 1,
                modelValue: _ctx.gearsModel,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.gearsModel) = $event)),
                options: _ctx.filtersDto.gears,
                type: "gears",
                onDrag: _cache[20] || (_cache[20] = (event) => _ctx.onFilterDrag('gears', event)),
                onDragend: _cache[21] || (_cache[21] = (event) => _ctx.onFilterDragEnd('gears', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['options'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 2,
                modelValue: _ctx.equipmentDetailsModel,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.equipmentDetailsModel) = $event)),
                options: _ctx.filtersDto.equipmentDetails,
                type: "equipmentDetails",
                onDrag: _cache[23] || (_cache[23] = (event) => _ctx.onFilterDrag('equipmentDetails', event)),
                onDragend: _cache[24] || (_cache[24] = (event) => _ctx.onFilterDragEnd('equipmentDetails', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['condition'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 3,
                modelValue: _ctx.conditionModel,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.conditionModel) = $event)),
                options: _ctx.filtersDto.type,
                type: "type",
                onDrag: _cache[26] || (_cache[26] = (event) => _ctx.onFilterDrag('type', event)),
                onDragend: _cache[27] || (_cache[27] = (event) => _ctx.onFilterDragEnd('type', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['brand'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 4,
                modelValue: _ctx.brandModel,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.brandModel) = $event)),
                options: _ctx.filtersDto.brand,
                type: "brand",
                onDrag: _cache[29] || (_cache[29] = (event) => _ctx.onFilterDrag('brand', event)),
                onDragend: _cache[30] || (_cache[30] = (event) => _ctx.onFilterDragEnd('brand', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['model'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 5,
                modelValue: _ctx.modelModel,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.modelModel) = $event)),
                options: _ctx.filtersDto.model,
                type: "model",
                onDrag: _cache[32] || (_cache[32] = (event) => _ctx.onFilterDrag('model', event)),
                onDragend: _cache[33] || (_cache[33] = (event) => _ctx.onFilterDragEnd('model', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['fueltype'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 6,
                modelValue: _ctx.fuelTypeModel,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.fuelTypeModel) = $event)),
                options: _ctx.filtersDto.fuelType,
                type: "fuelType",
                onDrag: _cache[35] || (_cache[35] = (event) => _ctx.onFilterDrag('fuelType', event)),
                onDragend: _cache[36] || (_cache[36] = (event) => _ctx.onFilterDragEnd('fuelType', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['firstregistrationYear'])
            ? (_openBlock(), _createBlock(_component_range_slider, {
                key: 7,
                modelValue: _ctx.yearModel,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.yearModel) = $event)),
                options: _ctx.filtersDto.year,
                type: "year",
                onDrag: _cache[38] || (_cache[38] = (event) => _ctx.onFilterDrag('year', event)),
                onDragend: _cache[39] || (_cache[39] = (event) => _ctx.onFilterDragEnd('year', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['emissionNedc'])
            ? (_openBlock(), _createBlock(_component_range_slider, {
                key: 8,
                modelValue: _ctx.emissionModel,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.emissionModel) = $event)),
                options: _ctx.filtersDto.emission,
                type: "emission",
                onDrag: _cache[41] || (_cache[41] = (event) => _ctx.onFilterDrag('emission', event)),
                onDragend: _cache[42] || (_cache[42] = (event) => _ctx.onFilterDragEnd('emission', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['damage'])
            ? (_openBlock(), _createBlock(_component_range_slider, {
                key: 9,
                modelValue: _ctx.damageAmountModel,
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.damageAmountModel) = $event)),
                options: _ctx.filtersDto.damageAmount,
                type: "damageAmount",
                onDrag: _cache[44] || (_cache[44] = (event) => _ctx.onFilterDrag('damageAmount', event)),
                onDragend: _cache[45] || (_cache[45] = (event) => _ctx.onFilterDragEnd('damageAmount', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['mileage'])
            ? (_openBlock(), _createBlock(_component_range_slider, {
                key: 10,
                modelValue: _ctx.mileageModel,
                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.mileageModel) = $event)),
                options: _ctx.filtersDto.mileage,
                type: "mileage",
                onDrag: _cache[47] || (_cache[47] = (event) => _ctx.onFilterDrag('mileage', event)),
                onDragend: _cache[48] || (_cache[48] = (event) => _ctx.onFilterDragEnd('mileage', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['availability'])
            ? (_openBlock(), _createBlock(_component_app_check_box_list, {
                key: 11,
                modelValue: _ctx.availabilityModel,
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.availabilityModel) = $event)),
                options: _ctx.filtersDto.availability,
                type: "availability",
                onDrag: _cache[50] || (_cache[50] = (event) => _ctx.onFilterDrag('availability', event)),
                onDragend: _cache[51] || (_cache[51] = (event) => _ctx.onFilterDragEnd('availability', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          (_ctx.showFilter['color'])
            ? (_openBlock(), _createBlock(_component_color_filter, {
                key: 12,
                modelValue: _ctx.colorsModel,
                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.colorsModel) = $event)),
                options: _ctx.filtersDto.colors,
                onDrag: _cache[53] || (_cache[53] = (event) => _ctx.onFilterDrag('colors', event)),
                onDragend: _cache[54] || (_cache[54] = (event) => _ctx.onFilterDragEnd('colors', event))
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "button btn-success",
              onClick: _cache[55] || (_cache[55] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
            }, [
              _createVNode(_component_i18n_t, { keypath: "dashboard.settings.saveBtn" }),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : _createCommentVNode("", true)
            ])
          ])
        ], 34)
      ])
    ])
  ]))
}